import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'

import IconTitle from 'components/resource/IconTitle'
import TeamInfo from 'components/resource/TeamInfo'
import NameEditor from './NameEditor'
import SortableNameCell from './SortableNameCell'
import icons from 'settings/icons'

const EditIcon = icons.edit
const ExpandIcon = icons.closed
const ContractIcon = icons.contract

const useStyles = makeStyles(theme => ({
  draggable: {
    paddingLeft: '0px',
  },
  clickToEdit: {
    width: '100%',
    cursor: 'text',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    paddingRight: theme.spacing(),
    paddingTop: '4px',
  },
  expandContainer: {
    minWidth: '26px',
    flexGrow: 0,
  },
  contentsContainer: {
    flexGrow: 1,
  },
  editNameContainer: {
    minWidth: '26px',
    flexGrow: 0,
  },
  footnote: {
    marginLeft: '60px',
  }
  
}))

const getDepthStyle = (depth) => {
  return {
    paddingLeft: `${10 + (depth * 24)}px`,
    width: '100%',
  }
}

const NameCell = ({
  sortMode,
  expanded,
  row,
  index,
  editName,
  readOnly,
  onChange,
  onSwapLinkChildren,
  onSwapFolderChildren,
  onExpand,
  onUpdateEditName,
  onCommitEditName,
  onResetEditName,
}) => {

  const classes = useStyles()

  const {
    item,
    group,
    depth,
    hasChildren,
  } = row

  const {
    resource,
  } = item

  const getExpandButton = () => {
    
    if(sortMode) return null
    if(readOnly) return null
    if(!onExpand) return null

    const isExpanded = expanded[item.id]
    const UseIcon = isExpanded ?
      ContractIcon :
      ExpandIcon

    return (
      <IconButton
        size="small"
        onClick={ () => {
          onExpand({
            id: item.id,
            value: isExpanded ? false : true,
          })
        }}
      >
        <UseIcon fontSize="small" />
      </IconButton>
    )
  }

  const getEditNameButton = () => {
    if(sortMode) return null
    if(readOnly) return null
    if(!onUpdateEditName) return null
    return (
      <IconButton
        size="small"
        onClick={ () => {
          onUpdateEditName({
            id: item.id,
            linkIndex: row.linkIndex,
            value: item.resource.name,
          })
        }}
      >
        <EditIcon fontSize="small" />
      </IconButton>
    )
  }

  const getIconWrapper = (children) => {
    return (
      <div>
        <IconTitle
          type={ resource.type }
        >
          { children }
        </IconTitle>
      </div>
    )
  }

  const getName = ({
    clickToEdit = false,
  } = {}) => {

    const name = (
      <Typography>
        { resource.name }
      </Typography>
    )
    
    const children = clickToEdit && !readOnly && onUpdateEditName ? (
      <div 
        className={ classes.clickToEdit }
        onClick={ () => {
          onUpdateEditName({
            id: item.id,
            linkIndex: row.linkIndex,
            value: item.resource.name,
          })
        }}
      >
        { name }
      </div>
    ) : name

    return getIconWrapper(children)
  }

  const getEditor = () => {
    if(readOnly || !onUpdateEditName || !onCommitEditName) return null
    const children = (
      <NameEditor
        value={ editName.value }
        onChange={ value => {
          onUpdateEditName({
            id: editName.id,
            linkIndex: row.linkIndex,
            value,
          })
        }}
        onCommit={ value => {
          onCommitEditName({
            id: editName.id,
            linkIndex: row.linkIndex,
            value,
          }) 
        }}
        onReset={ onResetEditName }
      />
    )

    return getIconWrapper(children)
  }

  const swap = (dragItem, dropItem) => {
    if(!sortMode) return
    if(!onSwapFolderChildren) return
    onSwapFolderChildren({
      dragItem,
      dropItem,
    })
  }

  const getSort = () => {
    if(!sortMode || !onSwapFolderChildren || !onChange) return getName()
    return (
      <SortableNameCell
        index={ index }
        group={ group }
        row={ row }
        onSwap={ swap }
        onSave={ onChange }
      >
        { getName() }
      </SortableNameCell>
    )
  }

  const getContents = () => {
    if(sortMode) {
      return getSort()
    }
    else if(!readOnly && editName && editName.id == item.id && editName.linkIndex == row.linkIndex) {
      return getEditor()
    }
    else {
      return getName({
        clickToEdit: true,
      })
    }
    
  }

  const isTeam = row.item.resource.type == 'team'

  return (
    <div style={ getDepthStyle(depth) }>
      <div className={ classes.container }>
        <div className={ classes.expandContainer }>
          { hasChildren && getExpandButton() }
        </div>
        <div className={ classes.contentsContainer }>
          { getContents() }
        </div>
        <div className={ classes.editNameContainer }>
          { getEditNameButton() }
        </div>
      </div>
      {
        isTeam && (
          <div className={ classes.footnote }>
            <TeamInfo
              resource={ row.item.resource }
            />
          </div>
        )
      }
    </div>
    
  )
}

export default NameCell

